import { useQuery } from "@tanstack/react-query";

import { getOrganizations } from "../../services/organizations";

const useGetOrganizations = () => {

    const queryFn = async () => {
        return await getOrganizations();
    };

    return useQuery({
        queryKey: ['organizations_tree'],
        queryFn,
        retry: 0,
    });
};

export default useGetOrganizations;